import { render, staticRenderFns } from "./developTeacherCrud.vue?vue&type=template&id=87d79b0c&"
import script from "./developTeacherCrud.vue?vue&type=script&lang=js&"
export * from "./developTeacherCrud.vue?vue&type=script&lang=js&"
import style0 from "./developTeacherCrud.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports